module.exports = {
          srcSet: __webpack_public_path__ + "public/images/c691beee0ae460fa44061fb1d207db7e-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/c691beee0ae460fa44061fb1d207db7e-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/c691beee0ae460fa44061fb1d207db7e-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/c691beee0ae460fa44061fb1d207db7e-1774.jpg"},
          
          width: 1774,
          height: 887
        }